import React from 'react';
import './ColorTag.scss';

export type ColorTagColor = 'green' | 'orange' | 'red' | 'blue' | 'grey' | 'grey-dark';

interface ColorTagProps {
  color: ColorTagColor;
  children: React.ReactNode;
  className?: string;
}

/** Small pill-shaped status/label tag in a palette colour (green / orange / red). */
const ColorTag: React.FC<ColorTagProps> = ({ color, children, className }) => (
  <span className={`color-tag color-tag--${color}${className ? ` ${className}` : ''}`}>
    {children}
  </span>
);

export default ColorTag;
